export default {
  model () {
    return {
      name: ''
    }
  },
  rules: {
    name: [
      {required: true, message: 'El nombre es requerido'},
      {min: 1, max: 255, message: 'El nombre debe ser entre 1 y 255 carácteres'}
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/dealers/dealers.model.js